import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as N from 'Common/notifications';
import { defineMessage, useIntl } from 'react-intl';
import { CategoriesTableParams } from 'utils/apiClient/services/inventory/types';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useCategories = (tableParams: CategoriesTableParams) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['inventory', 'categories', tableParams],
    queryFn: () => apiClient.Inventory.fetchCategories(tableParams),
    refetchOnWindowFocus: false,
    staleTime: 1000,
    retry: false,
  });
};

export const useSaveCategory = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Inventory.saveCategory,
    onSuccess: (_, variables) => {
      if (!variables.createdForProduct) {
        N.publishUIMessage(
          'success',
          defineMessage({ defaultMessage: 'Category saved successfully' })
        );
        queryClient.invalidateQueries({
          queryKey: ['inventory', 'categories'],
        });
      }
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

export const useDeleteCategory = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Inventory.deleteCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['inventory', 'categories'],
      });
      N.publishUIMessage(
        'success',
        defineMessage({ defaultMessage: 'Category successfully deleted' })
      );
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
